import React from 'react';
import { Link } from 'react-router-dom';
import './ComingSoon.css';

const ComingSoon = () => (
  <div className="cs-page">
    <div className="cs-glow" aria-hidden="true" />

    <div className="cs-content">
      <Link to="/chapters" className="cs-back">← All chapters</Link>

      <p className="cs-eyebrow">Expanding our network</p>

      <h1 className="cs-heading">This chapter is coming soon.</h1>

      <p className="cs-body">
        Project LTF is growing to new campuses across the country. This chapter is currently
        in its founding phase — leadership is being assembled and curriculum is being adapted
        for the local community.
      </p>

      <div className="cs-actions">
        <a
          href="mailto:staff@projectlevelthefield.com"
          className="cs-cta cs-cta--primary"
        >
          Get notified at launch
        </a>
        <Link to="/chapters" className="cs-cta cs-cta--secondary">
          See active chapters
        </Link>
      </div>

      <p className="cs-footnote">
        Interested in helping launch this chapter?{' '}
        <a href="mailto:staff@projectlevelthefield.com">Reach out to our expansion team.</a>
      </p>
    </div>
  </div>
);

export default ComingSoon;
